"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var unsolicited_eval_filter_html_1 = __importDefault(require("@components/filters/custom-filters/unsolicited-eval-filter.html"));
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('prUnsolicitedEvalFilterDirectiveLinker', [
        '$timeout',
        function (
        // @ts-ignore
        $timeout) {
            var operatorTranslations = {
                isEmpty: 'FSFILTERS.YES',
                isNotEmpty: 'FSFILTERS.NO'
            };
            var Linker = /** @class */ (function () {
                // @ts-ignore
                // @ts-ignore
                // @ts-ignore
                function Linker($rootScope, $fcFilter, $scope) {
                    var _this = this;
                    this.$rootScope = $rootScope;
                    this.$fcFilter = $fcFilter;
                    this.$scope = $scope;
                    this.onSelection = function () {
                        _this.updateFilter();
                    };
                    this.setupOperators = function () {
                        _this.$scope.operatorMenu = lodash_1.default.map(operatorTranslations, function (translateKey, value) {
                            return {
                                value: value,
                                label: _this.fcTranslate(translateKey)
                            };
                        });
                    };
                    this.updateFilter = function () {
                        _this.$scope.displayedFilter.filter.operator = _this.$templateScope.operator;
                        _this.$scope.displayedFilter.filter.operand = _this.$templateScope.operator === 'isEmpty';
                        _this.$rootScope.$broadcast('filterChanged');
                    };
                    this.getOperatorLabel = function () {
                        var scopeOperator = _this.$scope.displayedFilter.filter.operator;
                        // @ts-ignore
                        var operator = scopeOperator ? operatorTranslations[scopeOperator] : 'FSFILTERS.SELECT_OPERATOR';
                        return _this.fcTranslate(operator);
                    };
                    this.fcTranslate = this.$fcFilter('fcTranslate');
                    this.$scope.template = function () {
                        return unsolicited_eval_filter_html_1.default;
                    };
                    var operatorMenu = lodash_1.default.map(operatorTranslations, function (translateKey, value) {
                        return {
                            label: _this.fcTranslate(translateKey),
                            value: value
                        };
                    });
                    $timeout(function () {
                        // timeout is needed to wait for the template scope to be defined
                        _this.$templateScope = _this.$scope.$$childHead;
                        angular_1.extend(_this.$templateScope, {
                            operatorMenu: operatorMenu,
                            setupOperators: _this.setupOperators.bind(_this),
                            operator: _this.$scope.displayedFilter.filter.operator,
                            getOperatorLabel: _this.getOperatorLabel.bind(_this),
                            updateFilter: _this.updateFilter.bind(_this),
                            onSelection: _this.updateFilter.bind(_this)
                        });
                    });
                }
                return Linker;
            }());
            return Linker;
        }
    ]);
})(angular_1.module('qualtrics.pr'));
